import React from 'react'
import { getEls } from '../../utils/app-helpers'

export default class Gallery extends React.Component {
  selectImage(e) {
    if (typeof window === 'undefined') return
    const { app } = window
    const selectedEls = getEls('.gallery .selected')

    selectedEls.forEach(el => {
      el.classList.remove('selected')
    })
    e.target.classList.add('selected')
  }

  render() {
    const { folder, count } = this.props.inherit || this.props
    const images = []

    for (let i = 1; i <= count; i++) {
      const file = `/images/gallery/${folder}/${i}.jpg`

      images.push(<img key={i} src={file} alt="" />)
    }
    return (
      <div className="gallery" onClick={this.selectImage.bind(this)}>
        {images}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/gallery.js